var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "withdrawal-widget__confirm",
      attrs: { "data-test-id": "withdrawal-confirm" }
    },
    [
      _c(
        "div",
        {
          staticClass: "withdrawal-widget__confirm-row",
          attrs: { "data-test-id": "withdrawal-confirm-row" }
        },
        [
          _c(
            "p",
            { attrs: { "data-test-id": "withdrawal-confirm-asset-title" } },
            [_vm._v("\n      " + _vm._s(_vm.i18n.lbl_asset()) + "\n    ")]
          ),
          _vm._v(" "),
          _c("p", { attrs: { "data-test-id": "withdrawal-confirm-asset" } }, [
            _vm._v("\n      " + _vm._s(_vm.selectedAsset) + "\n    ")
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "withdrawal-widget__confirm-row",
          attrs: { "data-test-id": "withdrawal-confirm-row" }
        },
        [
          _c(
            "p",
            { attrs: { "data-test-id": "withdrawal-confirm-amount-title" } },
            [_vm._v("\n      " + _vm._s(_vm.i18n.lbl_amount()) + "\n    ")]
          ),
          _vm._v(" "),
          _c("p", { attrs: { "data-test-id": "withdrawal-confirm-amount" } }, [
            _vm._v(
              "\n      " +
                _vm._s(
                  _vm.i18n.c(_vm.options.amount) + " " + _vm.selectedAsset
                ) +
                "\n    "
            )
          ])
        ]
      ),
      _vm._v(" "),
      _vm.options.externalDetails.address
        ? _c(
            "div",
            {
              staticClass: "withdrawal-widget__confirm-row",
              attrs: { "data-test-id": "withdrawal-confirm-row" }
            },
            [
              _c(
                "p",
                {
                  attrs: { "data-test-id": "withdrawal-confirm-address-title" }
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.i18n.withdraw_external({ asset: "" })) +
                      "\n    "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "p",
                { attrs: { "data-test-id": "withdrawal-confirm-address" } },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s("" + _vm.options.externalDetails.address) +
                      "\n    "
                  )
                ]
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "withdrawal-widget__confirm-fees" }, [
        _c(
          "b",
          {
            staticClass: "withdrawal-widget__confirm-title",
            attrs: { "data-test-id": "withdrawal-confirm-fees-title" }
          },
          [_vm._v("\n      " + _vm._s(_vm.i18n.lbl_sender_fees()) + "\n    ")]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "withdrawal-widget__confirm-row",
            attrs: { "data-test-id": "withdrawal-confirm-row" }
          },
          [
            _c(
              "p",
              { attrs: { "data-test-id": "withdrawal-confirm-fixed-title" } },
              [_vm._v("\n        " + _vm._s(_vm.i18n.lbl_fixed()) + "\n      ")]
            ),
            _vm._v(" "),
            _c("p", { attrs: { "data-test-id": "withdrawal-confirm-fixed" } }, [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.i18n.c(_vm.options.fee.fixed) + " " + _vm.selectedAsset
                  ) +
                  "\n      "
              )
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "withdrawal-widget__confirm-row",
            attrs: { "data-test-id": "withdrawal-confirm-row" }
          },
          [
            _c(
              "p",
              { attrs: { "data-test-id": "withdrawal-confirm-percent-title" } },
              [
                _vm._v(
                  "\n        " + _vm._s(_vm.i18n.lbl_percent()) + "\n      "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "p",
              { attrs: { "data-test-id": "withdrawal-confirm-percent" } },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.i18n.c(_vm.options.fee.percent) +
                        " " +
                        _vm.selectedAsset
                    ) +
                    "\n      "
                )
              ]
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "withdrawal-widget__confirm-btns" },
        [
          _c(
            "md-button",
            {
              staticClass: "btn md-primary",
              attrs: { "data-test-id": "withdrawal-confirm-cancel-btn" },
              on: {
                click: function($event) {
                  return _vm.$emit(_vm.commonEvents.cancelClickEvent)
                }
              }
            },
            [_vm._v("\n      " + _vm._s(_vm.i18n.lbl_cancel()) + "\n    ")]
          ),
          _vm._v(" "),
          _c(
            "md-button",
            {
              staticClass: "btn md-mint",
              attrs: {
                "data-test-id": "withdrawal-confirm-confirm-btn",
                disabled: _vm.isPending
              },
              on: {
                click: function($event) {
                  return _vm.$emit(_vm.commonEvents.confirmClickEvent)
                }
              }
            },
            [
              !_vm.isPending
                ? _c("span", [
                    _vm._v(
                      "\n        " + _vm._s(_vm.i18n.lbl_confirm()) + "\n      "
                    )
                  ])
                : _c("md-progress-spinner", {
                    attrs: {
                      "md-diameter": 24,
                      "md-stroke": 3,
                      "md-mode": "indeterminate"
                    }
                  })
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fc42bc3e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fc42bc3e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/dashboard/widgets/WithdrawalWidget/ConfirmStep.vue
// module id = BCEH
// module chunks = 1